module.exports = __webpack_public_path__ + "img/a.57b8fd6f.png";